import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export const addPaymentMethod = async (paymentMethodId: string) => {
  try {
    const callParams = await getCallParams("POST", { paymentMethodId });
    const response = await makeCall(urls.addPaymentMethods, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
